import { render, staticRenderFns } from "./Home_advice_table.vue?vue&type=template&id=25a6f146&scoped=true&"
import script from "./Home_advice_table.vue?vue&type=script&lang=js&"
export * from "./Home_advice_table.vue?vue&type=script&lang=js&"
import style0 from "./Home_advice_table.vue?vue&type=style&index=0&id=25a6f146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a6f146",
  null
  
)

export default component.exports